import WithdrawalPage from './WithdrawalPage';

export default WithdrawalPage;
